import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as AuthActions from "../../actions/AuthActions";
import * as Comp from "../../components";
import * as M from "../../models";
import { LegacyApi } from "../../services/LegacyApi";
import { AppState } from "../../store";
import { AuthHelper } from "../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    logOut: () => dispatch(AuthActions.logOut()),
});

interface OwnProps {
}

type ConnectedState = Comp.Base.DefaultConnectedState & {
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    logOut: () => void;
};

interface OwnState {
}

class UserLogoutComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const legacyApi = new LegacyApi();
        const legacyAuthToken: M.Auth.LegacyAuthCookie = {
            m: this.props.tokenData.legacyMemberGuid,
            u: this.props.tokenData.legacyUserGuid,
            s: "asrs.client",
        };
        legacyApi.logout(legacyAuthToken);

        AuthHelper.clearTokenFromCookie();
        this.props.logOut();
    }

    public render() {
        return null;
    }
}

export const UserLogout: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(UserLogoutComponent);



// WEBPACK FOOTER //
// ./src/containers/account/Logout.tsx